import axios from 'axios'
import httpAdapter from 'axios/lib/adapters/http'

axios.defaults.xsrfCookieName = 'idun-csrf'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'
axios.defaults.withCredentials = true

const RETRY_DELAY_MS = 1500

// axios 0.19 rejects with exactly this message, and no response, when the
// browser got no usable answer. Aborts and timeouts carry ECONNABORTED and
// a different message, so they are not retried.
function isNetworkError (err) {
  return !err.response && err.message === 'Network Error'
}

function wait (ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

// Only for GETs: repeating a POST or PUT whose answer was lost could
// apply it twice.
export function retryOnNetworkError (send, delayMs = RETRY_DELAY_MS) {
  return send().catch((err) => {
    if (!isNetworkError(err)) {
      throw err
    }
    return wait(delayMs).then(send)
  })
}

export default class Http {
  static init (properties) {
    let httpMockAdapter = process.env.VUE_APP_USE_MOCK_DATA === 'true' || process.env.NODE_ENV === 'test' ? require('./HttpMockAdapter') : null
    if (httpMockAdapter) {
      axios.defaults.adapter = httpAdapter
      httpMockAdapter.default.prototype.init(axios)
    }
    axios.defaults.baseURL = process.API_ENDPOINT
    if (properties.hasOwnProperty('base_url')) {
      axios.defaults.baseURL = properties.base_url
    }
  }

  static get (properties) {
    Http.init(properties)
    return retryOnNetworkError(() => axios({
      method: 'get',
      url: properties.url,
      params: properties.params
    }))
  }

  static download (properties) {
    Http.init(properties)
    return retryOnNetworkError(() => axios.get(properties.url, {
      responseType: 'blob',
      params: properties.params
    }))
  }

  static post (properties) {
    Http.init(properties)
    return axios({
      method: 'post',
      url: properties.url,
      data: properties.data,
      headers: properties.headers
    })
  }

  static patch (properties) {
    Http.init(properties)
    return axios({
      method: 'patch',
      url: properties.url,
      data: properties.data
    })
  }

  static put (properties) {
    Http.init(properties)
    return axios({
      method: 'put',
      url: properties.url,
      data: properties.data
    })
  }

  static _delete (properties) {
    Http.init(properties)
    return axios({
      method: 'delete',
      url: properties.url
    })
  }
}
